import { ChangeEvent, FC, useState } from "react";
import { useDispatch } from "react-redux";

import { changeLimitsSettings } from "./../../../../store/settings/actionCreators";
import { IFormSettings } from "./../../../../services/forms";
import Switch from "./../../../../libs/Switch";

import styles from "./styles.module.scss";

interface IProps {
    limitSettings: IFormSettings["limits"];
}

const DateSection: FC<IProps> = ({ limitSettings }) => {
    const dispatch = useDispatch();

    const [dateWarning, setDateWarning] = useState<string>(limitSettings.formAvailability.disableBy.date.warning);

    const getDateWarningMessage = (e: ChangeEvent<HTMLInputElement>) => setDateWarning(e.target.value);

    const handleStateUpdate = (element: any) => {
        dispatch(
            changeLimitsSettings({
                prevState: limitSettings,
                currentState: {
                    formAvailability: {
                        ...limitSettings.formAvailability,
                        ...element,
                    },
                },
            }),
        );
    };

    return (
        <div className={styles.disableByDate}>
            <label>
                <Switch
                    checked={limitSettings.formAvailability.disableBy.date.isActive}
                    onChange={() =>
                        handleStateUpdate({
                            disableBy: {
                                ...limitSettings.formAvailability.disableBy,
                                date: {
                                    ...limitSettings.formAvailability.disableBy.date,
                                    isActive: !limitSettings.formAvailability.disableBy.date.isActive,
                                },
                            },
                        })
                    }
                />

                <p className={styles.subTitle}>Date</p>
            </label>

            {limitSettings.formAvailability.disableBy.date.isActive && (
                <>
                    <p className={styles.label}>The form will be accessible only between the specified dates.</p>

                    <div className={styles.rangeDateBox}>
                        <label className={styles.listenLabel}>
                            Start
                            <input
                                type={"date"}
                                max={limitSettings.formAvailability.disableBy.date.endDate}
                                value={limitSettings.formAvailability.disableBy.date.startDate}
                                className={styles.customInput}
                                onChange={e =>
                                    handleStateUpdate({
                                        disableBy: {
                                            ...limitSettings.formAvailability.disableBy,
                                            date: {
                                                ...limitSettings.formAvailability.disableBy.date,
                                                startDate: e.target.value,
                                            },
                                        },
                                    })
                                }
                            />
                        </label>

                        <label className={styles.listenLabel}>
                            End
                            <input
                                type={"date"}
                                min={limitSettings.formAvailability.disableBy.date.startDate}
                                value={limitSettings.formAvailability.disableBy.date.endDate}
                                className={styles.customInput}
                                onChange={e =>
                                    handleStateUpdate({
                                        disableBy: {
                                            ...limitSettings.formAvailability.disableBy,
                                            date: {
                                                ...limitSettings.formAvailability.disableBy.date,
                                                endDate: e.target.value,
                                            },
                                        },
                                    })
                                }
                            />
                        </label>
                    </div>

                    <div className={styles.rangeDateBox}>
                        <label className={styles.listenLabel}>
                            Warning Message
                            <input
                                type="text"
                                value={dateWarning}
                                onChange={e => getDateWarningMessage(e)}
                                className={styles.customInput}
                                onBlur={() =>
                                    handleStateUpdate({
                                        disableBy: {
                                            ...limitSettings.formAvailability.disableBy,
                                            date: {
                                                ...limitSettings.formAvailability.disableBy.date,
                                                warning: dateWarning,
                                            },
                                        },
                                    })
                                }
                            />
                        </label>
                    </div>
                </>
            )}
        </div>
    );
};

export default DateSection;
